<!-- <template>
<div class="highlighted-routes">
    <router-link v-if="this.item.url && !isExternalLink" v-bind:to="computeRoute">
        <div class="services-first-text">
            <h2>{{ item.title }}</h2>
        </div>
    </router-link>

    <a v-else-if="this.item.url" v-bind:href="item.url" target="_blank">
        <div class="services-first-text">
            <h2>{{ item.title }}</h2>
        </div>
    </a>

    <router-link v-else :to="{ name: 'menuDetailsNew', params: { id: item.id, slug: item.slug } }" v-bind:key="item.id">
        <div class="services-first-text">
            <h2>{{ item.title }}</h2>
        </div>
    </router-link>
</div>
 
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
    props: ["id"],
    name: "AppHighlightedServicesCard",
    data() {
        return {
            item: null,
            htmlContent: ""
        }
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            this.fetchContentById(this.id).then((contentResposnse) => {
                if (contentResposnse) {
                    this.item.title = contentResposnse.title;
                    this.item.url = contentResposnse.url;
                    this.item.slug = contentResposnse.slug;
                    this.htmlContent = contentResposnse.content;
                }
            });
        },
    },
    computed: {
        ...mapGetters(["getContentById", "getContentTypes", "getSelectedLanguage"]),
        isExternalLink() {
            return (this.item.url != null && ((this.item.contentTypeId == this.getContentTypes.linkContentTypeId && this.item.url.startsWith("http")) ||
                (this.item.contentTypeId == this.getContentTypes.highlightedServicesTypeId && this.item.url.startsWith("http"))));
        },
        isInternalLink() {
            return (this.item.url != null && ((this.item.contentTypeId == this.getContentTypes.linkContentTypeId && !this.item.url.startsWith("http")) ||
                (this.item.contentTypeId == this.getContentTypes.highlightedServicesTypeId && !this.item.url.startsWith("http"))));
        },
        computeRoute() {
            return this.isInternalLink ? { name: this.item.url } : { name: 'contentNew', params: { id: this.item.id, slug: this.item.slug } };
        },
    },
    created() {
        this.item = this.getContentById(this.id);
        this.loadData();
    },
    watch: {
        getSelectedLanguage() {
            this.loadData();
        },
    },
}
</script>

<style scoped>
.highlighted-routes{
    height: 100%;
    width: 100%;
}

.highlighted-routes a{
    height: 100%;
    width: 100%;
    text-decoration: none;
}

.highlighted-routes a:hover{
    text-decoration: none;
}

.services-first-button {
    background-color: transparent;
    border: none;
    align-items: end;
    float: right;
}

.services-first-button i {
    font-size: 40px;
    color: white;
}

.inner-text {
    align-self: center;
    width: 100%;
}

.services-first-text {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

}

.services-first-text h2 {
    font-size: 30px;
    color: #fff;
    font-weight: 600;
    margin-bottom: 0;
    text-transform: uppercase;
    margin-left: 5px;
    margin-right: 5px;
}

.services-first-text-p {
    max-height: 300px;
    color: var(--light-color);
    text-align: justify;
    font-size: 18px;
    line-height: 1.8;
    padding-right: 15px;
}

.services-first-text router-link {
    text-decoration: none;
}

.services-first-text:hover router-link,
.services-first-text:hover a {
    text-decoration: none;
}

.services-first-text-p a {
    color: var(--light-color);
    text-decoration: underline;
    font-weight: bold;
}

.services-first-text-p a:hover {
    color: #ffcc00;
}
</style> -->

<template>
    <component :is="linkComponent" v-bind="linkProps" class="quick-card">
        <div class="quick-card-top">
            <div class="quick-card-icon" v-html="cardIcon"></div>

            <div class="quick-card-content">
                <h3 class="card-title">{{ item.title }}</h3>
                <p class="card-subtitle" v-if="item.subtitle">
                    {{ item.subtitle }}
                </p>
            </div>
        </div>

        <div class="quick-card-footer">
            <span>{{ $t("learnMore") }} →</span>
        </div>
    </component>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        iconKey() {
            return (this.item.title || '')
                .toLowerCase()
                .trim()
                .replace(/[čć]/g, 'c')
                .replace(/š/g, 's')
                .replace(/đ/g, 'd')
                .replace(/ž/g, 'z')
                .replace(/\s+/g, '-');
        },

        cardIcon() {
            const icons = {
                registri: `<i class="fa fa-database"></i>`,
                proizvodi: `<i class="fa fa-briefcase"></i>`,
                'zakonska-regulativa': `<i class="fa fa-balance-scale"></i>`,
                'stara-devizna-stednja': `<i class="fa fa-money"></i>`
            };

            return icons[this.iconKey] || `<i class="fa fa-circle-o"></i>`;
        },

        isExternalLink() {
            return this.item.url && this.item.url.startsWith('http');
        },

        linkComponent() {
            return this.isExternalLink ? 'a' : 'router-link';
        },

        linkProps() {
            if (this.isExternalLink) {
                return {
                    href: this.item.url,
                    target: '_blank'
                };
            }

            if (this.item.url) {
                return {
                    to: { name: this.item.url }
                };
            }

            return {
                to: {
                    name: 'menuDetailsNew',
                    params: {
                        id: this.item.id,
                        slug: this.item.slug
                    }
                }
            };
        }
    }
}
</script>

<style>

a:hover{
    text-decoration: none !important;
}

.quick-card {
    min-height: 120px;
    padding: 22px 18px 16px;
    border: 1px solid #eef2f7;
    border-radius: 12px;
    background-color: #fafcff;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.035);
    transition: all 0.2s ease;
}

.quick-card:hover {
    border-color: #dbe7ff;
    box-shadow: 0 14px 30px rgba(37, 99, 235, 0.08);
    transform: translateY(-2px);
}

.quick-card-top {
    display: flex;
    align-items: flex-start;
    gap: 14px;
}

.quick-card-icon {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: var();
    /* color: #2563eb; */
    color: var(--main-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-bottom: 0;
    flex-shrink: 0;
    margin-top: 2px;
}

.quick-card-content {
    flex: 1;
}

.card-title {
    font-size: 20px;
    font-weight: 700;
    color: #1e3a5f;
    margin: 0 0 6px;
    line-height: 1.25;
}

.card-subtitle {
    font-size: 16px;
    font-weight: 400;
    color: #6b7280;
    margin: 0;
    line-height: 1.45;
}

.quick-card-footer {
    margin-left: 56px;
    margin-top: 12px;
    line-height: 1;
}

.quick-card-footer span {
    font-size: 14px;
    font-weight: 600;
    /* color: #2563eb; */
     color: #ea580c;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: transform 0.2s ease, color 0.2s ease;
}

.quick-card:hover .quick-card-footer span {
    transform: translateX(3px);
    color: #1d4ed8;
}
</style>